export interface ModalSupportData {
  data: { [key: string]: string };
  learniz: boolean;
  supportType?: SupportType;
}

export interface SourceSupportTrans {
  slug?: string; // Learniz
  value?: string; // Learniz
  translation?: { [key: string]: string }; // BO FO
  lang?: string; // BO FO
}

export enum SupportType {
  JIRA = 'jira',
  CLIENT = 'client',
}
